import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoThumbsUp = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ThumbsUp</title>
    <path
      d="M25.218 17.718c.3-.243 1.037-1.117.864-2.285-.173-1.168-1.143-1.715-2.286-1.715l-6.338-.044c1.182-6.858-.72-9.492-2.8-8.127-.988.649-1.03 1.886-1.62 4.743-.474 2.286-2.168 4.38-2.956 5.143H7.809a2.286 2.286 0 0 0-2.286 2.286v5.876c0 1.197.924 2.192 2.118 2.28l3.597.265c.197.571 2.121 1.125 5.655 1.125h5.011c1.632-.122 2.547-1.615 1.774-2.857m1.54-6.69c.71.802.766 2.37-.318 3.43m.319-3.43h-.814m.495 3.43c.655 1.385.017 2.599-1.222 3.26m1.222-3.26h-.494m-.728 3.26h-.284"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoThumbsUp;
